import './payment.scss';
import Component from '../../components/component/component';


export default class Payment extends Component {
    static initSelector: string = '.payment';

    public checkboxes: NodeListOf<Element>;
    public changePayMethodText: HTMLElement;
    public paymentOptions: NodeListOf<Element>;
    public optionsToggle: HTMLInputElement;
    public cardOptionRadios: NodeListOf<Element>;


    constructor(element: HTMLElement) {
        super(element);

        this.checkboxes = document.querySelectorAll('.payment__radio');
        this.changePayMethodText = document.getElementById('change-payment-method');
        this.paymentOptions = document.querySelectorAll('.payment__payments-list');
        this.optionsToggle= document.querySelector('.payment__options-toggle-input');
        this.cardOptionRadios = document.querySelectorAll('.card-options__radio');

        this.init();
    }

    init(): void {
        const isAnyPayMethodSelected: boolean = Array.from(this.checkboxes).some((checkbox: HTMLInputElement) => checkbox.checked);

        if (!isAnyPayMethodSelected) {
            this.changePayMethodText.style.visibility = 'hidden';
        }

        this.checkboxes.forEach((checkbox: HTMLInputElement) => {
            checkbox?.addEventListener('change', (event: Event) => {

                if ((<HTMLInputElement>event.target).checked) {
                    this.changePayMethodText.style.visibility = 'visible';
                    const siblings: ChildNode[] | null = this.getSiblings(<HTMLElement>(<HTMLElement>event.target).parentNode);

                    siblings.forEach((sibling: HTMLElement) => {
                        sibling.style.display = 'none';
                    });
                } else {
                    this.changePayMethodText.style.visibility = 'hidden';
                    const siblings: ChildNode[] = this.getSiblings(<HTMLElement>(<HTMLElement>event.target).parentNode);

                    siblings.forEach((sibling: HTMLElement) => {
                        sibling.style.display = 'block';
                    });
                    this.uncheckCardOptionRadios();
                }
            });

            checkbox.addEventListener('mouseup', () => {
                if (checkbox.checked) {
                    setTimeout(() => {
                        checkbox.checked = false;
                        this.paymentOptions.forEach((option: HTMLInputElement) => {
                            option.style.display = 'block';
                        });
                        this.optionsToggle.checked = true;
                        this.changePayMethodText.style.visibility = 'hidden';
                    }, 0);
                }
            });

            const label: HTMLLabelElement = document.querySelector('label[for="' + checkbox.id + '"]');

            label?.addEventListener('mouseup', () => {
                if (checkbox.checked) {
                    setTimeout(() => {
                        checkbox.checked = false;
                        this.paymentOptions.forEach((option: HTMLInputElement) => {
                            option.style.display = 'block';
                        });
                        this.optionsToggle.checked = true;
                        this.changePayMethodText.style.visibility = 'hidden';
                    }, 0);
                }
            });
        });


        if (this.optionsToggle) {
            this.optionsToggle?.addEventListener('change', (event: Event) => {
                if (!(<HTMLInputElement>event.target).checked) {
                    this.changePayMethodText.style.visibility = 'hidden';
                    this.checkboxes.forEach((checkbox: HTMLInputElement) => {
                        checkbox.checked = false;
                    });

                    this.paymentOptions.forEach((option: HTMLInputElement) => {
                        option.style.display = 'block';
                    });

                    this.uncheckCardOptionRadios();
                    (<HTMLInputElement>event.target).checked = true;
                } else {
                    this.checkboxes.forEach((checkbox: HTMLInputElement) => {
                        checkbox.checked = false;
                    });
                    this.changePayMethodText.style.visibility = 'hidden';
                }
            });
        }

    }

    public uncheckCardOptionRadios(): void {
        this.cardOptionRadios.forEach((radio: HTMLInputElement) => {

            if (radio.checked) {
                radio.checked = false;
            }
        });
    }

    public getSiblings(elem: ChildNode): ChildNode[] {
        const siblings: ChildNode[] = [];
        let sibling: ChildNode | null = elem.parentNode.firstChild;

        while (sibling) {
            if (sibling.nodeType === 1 && sibling !== elem) {
                siblings.push(sibling);
            }
            sibling = sibling.nextSibling;
        }

        return siblings;
    }
}
